import Ctl from '@/orm/models/Ctl'
import Member from '@/orm/models/Member'
import OrgTeamRole from '@/orm/models/OrgTeamRole'
import RefereeRole from '@/orm/models/RefereeRole'
import { Model, useRepo } from 'pinia-orm'
import { BelongsTo, Num, Str } from 'pinia-orm/decorators'

export default class CtlNomination extends Model {
    static entity = 'ctl-nominations'

    @Str('', { notNullable: true })
    declare id: string
    @Num(0, { notNullable: true })
    declare ctlId: number
    @BelongsTo(() => Ctl, 'ctlId')
    declare ctl: Ctl
    @Str('', { notNullable: true })
    declare regId: string
    @Str('', { notNullable: true })
    declare memberId: string
    @BelongsTo(() => Member, 'memberId')
    declare member: Member
    @Num(0, { notNullable: true })
    declare roleId: number

    get refereeRole(): RefereeRole | null {
        return useRepo(RefereeRole).find(this.roleId)
    }

    get orgTeamRole(): OrgTeamRole | null {
        return useRepo(OrgTeamRole).find(this.roleId)
    }

    static piniaOptions = {
        persist: true,
    }
}
